import React from 'react'

import { ProductTabsSliceProps } from './types'
import ProductTableTabsSection from '../../sections/ProductTableTabsSection'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import { mapButtonProps } from '../../atoms/Button/utils'

const ProductTabsSlice: React.FC<ProductTabsSliceProps> = ({ slice }) => {
  const { group } = usePageContext()
  const { items = [] } = slice

  return (
    <ProductTableTabsSection
      inner="inners.fullWidth"
      paddingTop={['24px', '', '30px']}
      paddingBottom={['80px', '', '30px']}
      headingPadding={['38px', '', '87px']}
      bgColor="grayLight"
      data={{
        withSearch: true,
        withPagination: true,
        list: items.map((item, index) => {
          const { tab_title = '', tab_image, content_document } = item || {}
          const {
            product_name,
            image,
            video,
            icons,
            title,
            description,
            caption,
            cta_link,
            cta_text,
            cta_type,
            cta_caption,
            cta_is_centered,
            cta_caption_mobile_size,
            cta_caption_desktop_size,
            demo_link,
            demo_text,
            demo_prefix,

            col_1_heading,
            col_2_heading,
            col_3_heading,
            col_4_heading,
            col_5_heading,
            col_6_heading,
            col_7_heading,
            col_8_heading,
            col_9_heading,
            col_10_heading,
            rows = []
          } = content_document?.document?.data || {}

          return {
            id: `${index}`,
            tabKey: `${index}`,
            tabIcon: tab_image,
            title: tab_title,
            item: {
              product: {
                mediaBlock: {
                  title: product_name,
                  media: {
                    image: image
                      ? {
                          publicURL: image.url,
                          childImageSharp: image && {
                            gatsbyImageData: image.gatsbyImageData
                          },
                          width: image?.dimensions?.width,
                          height: image?.dimensions?.height,
                          alt: image?.alt
                        }
                      : undefined,
                    video: {
                      url: video?.url
                    }
                  },
                  iconList: icons?.map((icon, index) => ({
                    key: index,
                    title: icon?.icon_title,
                    icon: icon?.icon
                  }))
                },
                title: title?.text || '',
                description: description?.html || '',
                cta: mapButtonProps(
                  cta_type,
                  cta_text,
                  resolvePrismicLink(cta_link, group),
                  cta_link?.link_type,
                  cta_caption,
                  cta_caption_mobile_size,
                  cta_caption_desktop_size,
                  cta_is_centered
                ),
                demo: {
                  urlText: demo_text,
                  url: resolvePrismicLink(demo_link, group),
                  urlIsExternal: true,
                  prefix: demo_prefix || ''
                },
                caption: caption?.text
              },
              table: rows.map((row) => {
                const {
                  col_1_content,
                  col_2_content,
                  col_3_content,
                  col_4_content,
                  col_5_content,
                  col_6_content,
                  col_7_content,
                  col_8_content,
                  col_9_content,
                  col_10_content
                } = row || {}

                const rowData: Record<string, string>[] = []

                if (col_1_heading) {
                  rowData.push({ [col_1_heading]: col_1_content?.text || '' })
                }

                if (col_2_heading) {
                  rowData.push({ [col_2_heading]: col_2_content?.text || '' })
                }

                if (col_3_heading) {
                  rowData.push({ [col_3_heading]: col_3_content?.text || '' })
                }

                if (col_4_heading) {
                  rowData.push({ [col_4_heading]: col_4_content?.text || '' })
                }

                if (col_5_heading) {
                  rowData.push({ [col_5_heading]: col_5_content?.text || '' })
                }

                if (col_6_heading) {
                  rowData.push({ [col_6_heading]: col_6_content?.text || '' })
                }

                if (col_7_heading) {
                  rowData.push({ [col_7_heading]: col_7_content?.text || '' })
                }

                if (col_8_heading) {
                  rowData.push({ [col_8_heading]: col_8_content?.text || '' })
                }

                if (col_9_heading) {
                  rowData.push({ [col_9_heading]: col_9_content?.text || '' })
                }

                if (col_10_heading) {
                  rowData.push({ [col_10_heading]: col_10_content?.text || '' })
                }

                return rowData
              })
            }
          }
        })
      }}
    />
  )
}

export default ProductTabsSlice
